import { PromoMessageSchema } from '../configSchema/EngineSchema';
import { z } from 'zod';

export enum PromoMessageIcons {
	TimeIsMoney = 'TimeIsMoney'
}

export type PromoMessage = z.infer<typeof PromoMessageSchema>;
